(function(angular, module) {var GrantReportReport, GrantReportViewController, ReportController, SectionController, detailsDirective, nameCellDirective, resolveGrantReportConfig, resolveGrantReportIndex, resolveReport, resoveSectionConfig, stateDefinitions,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

stateDefinitions = function($stateProvider, TagUrl) {
  'ngInject';
  var sectionTemplates, tagUrl;
  $stateProvider.state('reports.amc.grantReport', {
    url: '/grant-report',
    templateUrl: 'reports/amc/grantReport',
    abstract: true
  });
  $stateProvider.state('reports.amc.grantReport.index', {
    url: '',
    templateUrl: 'reports/amc/grantReportIndex',
    resolve: {
      grantReports: resolveGrantReportIndex
    },
    controllerAs: 'ctrl',
    controller: function(grantReports) {
      this.grantReports = grantReports;
      this.completePercent = function(year) {
        var percent;
        percent = year.slots === 0 ? 0 : year.complete / year.slots;
        return Math.floor(percent * 100);
      };
    }
  });
  tagUrl = new TagUrl().addTagTypes(['program', 'location']);
  $stateProvider.state('reports.amc.grantReport.view', {
    url: tagUrl.buildUrl('/{year:int}?{page:int}{sort}{direction}'),
    params: tagUrl.params,
    data: {
      tagUrl: tagUrl
    },
    abstract: true,
    reloadOnSearch: false,
    templateUrl: 'reports/amc/grantReportView',
    resolve: {
      config: resolveGrantReportConfig
    },
    controllerAs: 'ctrl',
    controller: GrantReportViewController
  });
  sectionTemplates = {
    slots: 'grantReportSlots',
    outcomes: 'grantReportOutcomes',
    info: 'grantReportInfo'
  };
  return $stateProvider.state('reports.amc.grantReport.view.section', {
    reloadOnSearch: false,
    url: '/{section}',
    templateUrl: function($stateParams) {
      var name;
      name = sectionTemplates[$stateParams.section] || 'grantReportSection';
      return "reports/amc/" + name;
    },
    resolve: {
      config: resoveSectionConfig,
      report: resolveReport
    },
    controller: ReportController,
    controllerAs: 'ctrl'
  });
};


/* @ngInject */

resolveGrantReportIndex = function($http, ApiUrl) {
  var url;
  url = ApiUrl('reports', 'amc', 'grant_report');
  return $http.get(url).then(function(response) {
    return response.data.items;
  });
};


/* @ngInject */

resolveGrantReportConfig = function($http, $stateParams, ApiUrl) {
  var url;
  url = ApiUrl('amc_grant_report', 'config', $stateParams.year);
  return $http.get(url).then(function(response) {
    return response.data.item;
  });
};


/* @ngInject */

resoveSectionConfig = function($stateParams, config) {
  var j, len, ref, section;
  ref = config.sections.sections;
  for (j = 0, len = ref.length; j < len; j++) {
    section = ref[j];
    if (section.name === $stateParams.section) {
      return section;
    }
  }
};


/* @ngInject */

resolveReport = function($stateParams, GrantReportReport, config) {
  return new GrantReportReport($stateParams.year, $stateParams.section, config);
};

GrantReportViewController = (function() {

  /* @ngInject */
  function GrantReportViewController($scope, $timeout, $stateParams, config) {
    this.triggerRefresh = bind(this.triggerRefresh, this);
    this.scope = $scope;
    this.timeout = $timeout;
    this.config = config;
    this.grantYear = $stateParams.year;
    this.scope.triggerRefresh = this.triggerRefresh;
  }

  GrantReportViewController.prototype.refreshTags = function(params) {
    return this.timeout((function(_this) {
      return function() {
        _this.lastParams = params;
        _this.downloadUrl = _this.buildDownloadURL();
        return _this.scope.$broadcast('tagRefresh', params);
      };
    })(this));
  };

  GrantReportViewController.prototype.triggerRefresh = function() {
    if (this.lastParams != null) {
      return this.refreshTags(this.lastParams);
    }
  };

  GrantReportViewController.prototype.buildDownloadURL = function() {
    var items, j, len, name, parts, ref, url, value;
    url = "/api/reports/amc/grant_report/" + this.grantYear + ".xlsx";
    parts = [];
    ref = this.lastParams;
    for (name in ref) {
      items = ref[name];
      for (j = 0, len = items.length; j < len; j++) {
        value = items[j];
        parts.push(name + "=" + (encodeURIComponent(value)));
      }
    }
    return url + "?" + (parts.join("&"));
  };

  return GrantReportViewController;

})();

ReportController = (function() {

  /* @ngInject */
  function ReportController($scope, report) {
    var makeMetric;
    this.report = report;
    this.refresh = bind(this.refresh, this);
    this.scope = $scope;
    this.scope.triggerRefresh();
    this.scope.$on('tagRefresh', this.refresh);
    makeMetric = function(label, col, percent) {
      if (percent == null) {
        percent = true;
      }
      return {
        label: label,
        act_col: col,
        obj_col: col + '_objective',
        unit: percent ? '%' : '',
        mult: percent ? 100 : 1
      };
    };
    this.outcomeMetrics = [makeMetric('Ed Award Rate', 'ed_award_rate')];
    if (this.report.grant_year <= 2015) {
      this.outcomeMetrics = this.outcomeMetrics.concat([makeMetric('Full Ed Award', 'full_ed_award', false), makeMetric('Credential Rate', 'credential_rate'), makeMetric('Job Placement', 'job_placement_rate')]);
    } else {
      this.outcomeMetrics = this.outcomeMetrics.concat([makeMetric('No Credential', 'no_credential', false), makeMetric('30 Day Credential Rate', 'credential_30d'), makeMetric('1 Year Credential Rate', 'credential_1y'), makeMetric('30 Day Job Placement', 'job_placement_30d'), makeMetric('1 Year Job Placement', 'job_placement_1y')]);
    }
  }

  ReportController.prototype.refresh = function(event, params) {
    return this.report.update(params);
  };

  ReportController.prototype.slotClasses = function(item) {
    var denom, num;
    num = item.members;
    denom = item.slots;
    return {
      green: num === denom,
      red: num > denom,
      blue: num === 0
    };
  };

  ReportController.prototype.showDetails = function(data, item) {
    if (this.isShown(data, item)) {
      this.hideDetails();
    } else {
      this.detailsData = data;
      this.detailsItem = item;
    }
  };

  ReportController.prototype.hideDetails = function() {
    this.detailsData = null;
    this.detailsItem = null;
  };

  ReportController.prototype.isShown = function(data, item) {
    return (this.detailsData != null) && data.id === this.detailsData.id && ((item == null) || item.name === this.detailsItem.name);
  };

  return ReportController;

})();

SectionController = (function() {

  /* @ngInject */
  function SectionController(config) {
    this.config = config;
  }

  return SectionController;

})();


/* @ngInject */

GrantReportReport = function(Report) {
  var sortColumns;
  sortColumns = {
    slots: ['name', 'completion', 'enrollment', 'total_slots', 'members', 'planned'],
    outcomes: ['name', "credential_rate_objective", "credential_rate", "ed_award_rate_objective", "ed_award_rate", "full_ed_award_objective", "full_ed_award", "job_placement_objective", "job_placement", "no_credential", "credential_1y", "credential_30d", "job_placement_1y", "job_placement_30d"],
    info: ['name', 'members', 'applicants', 'confirm_80_20', 'last_enrollment']
  };
  GrantReportReport = (function(superClass) {
    var buildSortColumns, getConfigItems;

    extend(GrantReportReport, superClass);

    GrantReportReport.prototype.$isList = true;

    function GrantReportReport(grant_year, section1, config1) {
      this.grant_year = grant_year;
      this.section = section1;
      this.config = config1;
      this.sortColumns = sortColumns[this.section] || [];
      if (this.config != null) {
        this.sortColumns = buildSortColumns(this.config);
        this.metrics = getConfigItems(this.config, 'metric');
        this.events = getConfigItems(this.config, 'service_event');
        this.narratives = getConfigItems(this.config, 'narrative');
      }
      GrantReportReport.__super__.constructor.call(this, ['reports/amc/grant_report', this.grant_year, this.section]);
    }

    Object.defineProperties(GrantReportReport.prototype, {
      $sorterConfig: {
        get: function() {
          return {
            "default": 'name',
            columns: this.sortColumns
          };
        }
      }
    });

    getConfigItems = function(config, type) {
      var i, j, len, ref, results;
      ref = config.items;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        if (i.type === type) {
          results.push(i);
        }
      }
      return results;
    };

    buildSortColumns = function(config) {
      var columns, item, j, len, ref;
      columns = [];
      ref = config.items;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (item.type === 'metric') {
          columns.push(item.name + '_actual');
          if (item.has_objective) {
            columns.push(item.name + "_objective");
          }
        }
        if (item.type === 'service_event') {
          columns.push(item.name + '_participated');
        }
        if (item.type === 'narrative') {
          columns.push(item.name + '_word_count');
        }
      }
      return columns;
    };

    return GrantReportReport;

  })(Report);
  Report.addExtraParameter(GrantReportReport, 'hide_disabled');
  return GrantReportReport;
};

nameCellDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'reports/amc/amcGrantReportNameCell',
    scope: {
      data: '='
    },
    link: function(scope) {
      return scope.params = function() {
        var ref, ref1;
        return {
          slug: (ref = scope.data) != null ? ref.slug : void 0,
          grant_year: (ref1 = scope.data) != null ? ref1.grant_year : void 0
        };
      };
    }
  };
};

detailsDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'reports/amc/amcGrantReportDetails',
    scope: {
      data: '=',
      item: '=',
      close: '&'
    },
    link: function(scope) {
      scope.getData = function(name) {
        if (name != null) {
          return scope.data[scope.item.name + "_" + name];
        } else {
          return scope.data[scope.item.name];
        }
      };
      return scope.click = function() {
        return scope.close({
          item: scope.item,
          data: scope.data
        });
      };
    }
  };
};

module.config(stateDefinitions);

module.directive('amcGrantReportDetails', detailsDirective);

module.directive('amcGrantReportNameCell', nameCellDirective);

module.service('GrantReportReport', GrantReportReport);
})(angular, angular.module("dybReportsAmc"));